module.exports = __webpack_public_path__ + "img/trip-advisor-rating.a944ab43.svg";